import script from "./SubcategoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SubcategoryModal.vue?vue&type=script&setup=true&lang=js"

import "./SubcategoryModal.vue?vue&type=style&index=0&id=03c83494&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03c83494"]])

export default __exports__